<section>
    <div class="container">
        <div class="login-section card mx-auto p-5">
            <div class="header w-100 text-center mb-4">
                <img src="assets/Bergh-Bouwgroep-logo.png" height="64">
            </div>
            <div class="title">
                <h6 class="mb-4 bergh-text-primary text-center">{{lang.activateAccount.title}}</h6>
            </div>
            <form [formGroup]="activateAccountForm" (ngSubmit)="activateAccountFormSubmit()" id="activateAccountForm">
                <div class="form-group">
                    <label for="nameInput" class="m-0">{{lang.activateAccount.nameLabel}}</label>
                    <h5 class="bergh-text-primary">{{activateAccountForm.controls['name'].value}}</h5>
                </div>
                <div class="helper-text w-100 m-0 text-right">
                    <small class="font-weight-bold bergh-text-secondary font-italic">
                        {{lang.activateAccount.passwordHelperText}}
                    </small>
                </div>
                <div class="form-group">
                    <label for="passwordInput">{{lang.activateAccount.passwordLabel}}</label>
                    <input type="password"
                           [ngClass]="{'form-control':true,'is-invalid':activateAccountForm.controls['password'].invalid && activateAccountForm.controls['password'].touched}"
                           id="passwordInput"
                           formControlName="password"
                           placeholder="{{lang.activateAccount.passwordPlaceholder}}">
                    <div class="invalid-feedback" id="emailError">{{lang.activateAccount.passwordError}}</div>
                </div>
                <div class="form-group">
                    <label for="repeatPasswordInput">{{lang.activateAccount.repeatPasswordLabel}}</label>
                    <input type="password"
                           [ngClass]="{'form-control':true,'is-invalid':activateAccountForm.controls['repeatPassword'].invalid && activateAccountForm.controls['repeatPassword'].touched}"
                           id="repeatPasswordInput"
                           formControlName="repeatPassword"
                           placeholder="{{lang.activateAccount.repeatPasswordPlaceholder}}"
                           (change)="passwordCheck()">
                    <div class="invalid-feedback" id="emailError">{{lang.activateAccount.repeatPasswordError}}</div>
                </div>
                <div class="form-group mt-5">
                    <button class="btn bergh-bg-secondary text-white w-100" type="submit" id="submitBtn" [disabled]="activateAccountForm.invalid">{{lang.activateAccount.activateAccountBtn}}</button>
                </div>
            </form>
        </div>
    </div>
</section>
